import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';

import { ChangeAutoRenewalButtonProps } from '../types';

import styles from './index.module.scss';

const getButtonText = (
  isLinkingInProcess: boolean,
  isNeedPayment: boolean,
  licensesSubscriptionCost: number,
  isPendingAcceptanceAdvanced: boolean
) => {
  if (isPendingAcceptanceAdvanced) {
    return TEXTS.BILLING_LICENSES_ACCEPTANCE_ADVANCED_BUTTON_TEXT;
  }

  if (isLinkingInProcess) {
    return TEXTS.BILLING_BIND_CARD_LOADING(licensesSubscriptionCost);
  }

  if (isNeedPayment) {
    return TEXTS.BILLING_LICENSES_AMOUNT_BUTTON_TITLE(licensesSubscriptionCost);
  }

  return TEXTS.BILLING_LICENSES_SUBMIT_BUTTON_TEXT;
};

const ChangeAutoRenewalButton: FC<ChangeAutoRenewalButtonProps> = ({
  isDisabled,
  isLoading,
  isNeedPayment,
  licensesSubscriptionCost,
  isLinkingInProcess,
  isHintShow,
  isPendingAcceptanceAdvanced,
  onClick,
}) => (
  <Popper
    key="button_submit_licenses"
    triggerNode={
      <div>
        <Button
          elementId="button_submit_licenses"
          type={ButtonType.PRIMARY}
          isDisabled={isDisabled}
          isLoading={isLoading}
          onClick={onClick}>
          {getButtonText(isLinkingInProcess, isNeedPayment, licensesSubscriptionCost, isPendingAcceptanceAdvanced)}
        </Button>
      </div>
    }
    placement={HintPlacement.PLACEMENT_BOTTOM}
    isShow={isHintShow && !isPendingAcceptanceAdvanced}
    popperClassName={styles.actionButtonPopper}
    containerClassName={styles.actionButtonPopperContainer}>
    {TEXTS.BILLING_LICENSES_LIST_BUTTON_TOOLTIP}
  </Popper>
);

export default React.memo(ChangeAutoRenewalButton);
